import React, { useEffect, useMemo, useState } from "react";
import GlobalStyles from "@mui/material/GlobalStyles";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  FunctionField,
  TopToolbar,
  ExportButton,
  TextInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  useRecordContext,
  useNotify,
  useRefresh,
} from "react-admin";


import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Checkbox,
  Stack,
  TextField as MuiTextField,
  Box,
  Paper,
  Divider,
} from "@mui/material";
import { useListContext } from "react-admin";


import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const COLORS = {
  navy: "#0b1f3a",
  navySoft: "#15345d",
  blue: "#2563eb",
  blueSoft: "#eff6ff",
  orange: "#f59e0b",
  orangeSoft: "#fff7ed",
  green: "#10b981",
  greenSoft: "#ecfdf5",
  red: "#ef4444",
  redSoft: "#fff1f2",
  text: "#0f172a",
  textSoft: "#64748b",
  page: "#f3f6fb",
  border: "#e2e8f0",
};

/* ======================================================
   🌍 DİL METİNLERİ (TR / EN / DE)
====================================================== */
const T = {
  tr: {
    listTitle: "👥 Kullanıcılar",
    exportBtn: "Dışa Aktar",
    search: "Ara",
    role: "Rol",
    status: "Durum",
    active: "Aktif",
    passive: "Pasif",

    name: "Ad Soyad",
    email: "E-posta",
    roleCol: "Rol",
    isActive: "Aktif mi?",
    createdAt: "Oluşturma",
    lastLogin: "Son Giriş",
 selected: "Seçilen dosya",
  noFile: "Dosya seçilmedi",
delete: "Sil",
confirmDelete: "Bu kullanıcı silinsin mi?",
deleted: "Kullanıcı silindi",

    commCenter: "İletişim Merkezi",
    bulkTitle: "Seçili Kullanıcılara Mesaj / Evrak Gönder",
    subject: "Başlık",
    message: "Mesaj",
    file: "Dosya (Resim / PDF / Word)",
    send: "Gönder",
    selectWarning: "Lütfen en az 1 kullanıcı seçin",
    queued: "Gönderim kuyruğa alındı",

    detailsTitle: "Kullanıcı Detayı",
  },
  en: {
    listTitle: "👥 Users",
    exportBtn: "Export",
    search: "Search",
    role: "Role",
    status: "Status",
    active: "Active",
    passive: "Inactive",

    name: "Full Name",
    email: "Email",
    roleCol: "Role",
    isActive: "Active?",
    createdAt: "Created",
    lastLogin: "Last Login",
 selected: "Selected file",
  noFile: "No file selected",
delete: "Delete",
confirmDelete: "Delete this user?",
deleted: "User deleted",


    commCenter: "Communication Center",
    bulkTitle: "Send Message / Document to Selected Users",
    subject: "Subject",
    message: "Message",
    file: "File (Image / PDF / Word)",
    send: "Send",
    selectWarning: "Please select at least 1 user",
    queued: "Send queued",

    detailsTitle: "User Details",
  },
  de: {
    listTitle: "👥 Benutzer",
    exportBtn: "Exportieren",
    search: "Suchen",
    role: "Rolle",
    status: "Status",
    active: "Aktiv",
    passive: "Inaktiv",

    name: "Name",
    email: "E-Mail",
    roleCol: "Rolle",
    isActive: "Aktiv?",
    createdAt: "Erstellt",
    lastLogin: "Letzte Anmeldung",
 selected: "Ausgewählte Datei",
  noFile: "Keine Datei ausgewählt",
delete: "Löschen",
confirmDelete: "Benutzer löschen?",
deleted: "Benutzer gelöscht",

    commCenter: "Kommunikationszentrale",
    bulkTitle: "Nachricht / Dokument an ausgewählte Benutzer senden",
    subject: "Betreff",
    message: "Nachricht",
    file: "Datei (Bild / PDF / Word)",
    send: "Senden",
    selectWarning: "Bitte mindestens 1 Benutzer auswählen",
    queued: "Senden vorgemerkt",

    detailsTitle: "Benutzerdetails",
  },
};

const ALLOWED = ["tr", "en", "de"];
function useUiTexts() {
  const [uiLang, setUiLang] = useState(() => {
    const l = (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase();
    return ALLOWED.includes(l) ? l : "tr";
  });

  useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  return T[ALLOWED.includes(uiLang) ? uiLang : "tr"];
}

/* ======================================================
   🔧 YARDIMCILAR (MEVCUT TABLO UYUMLU)
====================================================== */
const pick = (r, keys) =>
  keys.map((k) => r?.[k]).find((v) => v !== undefined && v !== null && v !== "");

const fullName = (r) =>
  pick(r, ["ad_soyad", "full_name"]) ||
  [pick(r, ["ad", "first_name"]), pick(r, ["soyad", "last_name"])]
    .filter(Boolean)
    .join(" ") ||
  "-";

const createdFrom = (r) => pick(r, ["created_at", "createdAt", "created"]);
const lastLoginFrom = (r) => pick(r, ["last_login", "lastLogin", "son_giris"]);

/* ======================================================
   🔝 ÜST BAR
====================================================== */
const ListActions = () => {
  const TT = useUiTexts();
  return (
    <TopToolbar
      sx={{
        width: "100%",
        px: { xs: 1.5, sm: 0 },
        py: 1.25,
        justifyContent: "flex-end",
      }}
    >
      <ExportButton
        label={TT.exportBtn}
        sx={{
          minHeight: 42,
          px: 2.25,
          borderRadius: 2.5,
          textTransform: "none",
          fontWeight: 850,
          bgcolor: `${COLORS.blue} !important`,
          color: "#fff !important",
          boxShadow: "0 8px 20px rgba(37,99,235,.18)",
          "&:hover": {
            bgcolor: "#1d4ed8 !important",
          },
        }}
      />
    </TopToolbar>
  );
};


/* ======================================================
   🗑️ SİLME BUTONU (DİLLİ)
====================================================== */
const DeleteUserButton = ({ record }) => {
  const TT = useUiTexts();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleDelete = async () => {
    if (!window.confirm(TT.confirmDelete)) return;

    try {
      const res = await fetch(`/api/kullanicilar/${record.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!res.ok) throw new Error();

      notify(TT.deleted, { type: "success" });
      refresh();
    } catch {
      notify(TT.error || "Hata oluştu", { type: "error" });
    }
  };

  return (
    <Button
      color="error"
      size="small"
      variant="contained"
      onClick={(e) => {
        e.stopPropagation();
        handleDelete();
      }}
      sx={{
        minHeight: 38,
        px: 1.5,
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 850,
        bgcolor: COLORS.red,
        boxShadow: "none",
        "&:hover": {
          bgcolor: "#dc2626",
          boxShadow: "none",
        },
      }}
    >
      {TT.delete}
    </Button>
  );
};
const SelectAllCheckbox = ({ selectedIds, setSelectedIds }) => {
  const { data } = useListContext();

  if (!data || data.length === 0) return null;

  const allSelected = selectedIds.length === data.length;
  const partial =
    selectedIds.length > 0 && selectedIds.length < data.length;

  return (
  <Checkbox
  checked={allSelected}
  indeterminate={partial}
  onChange={() => {
  setSelectedIds((prev) => {
    if (prev.length === data.length) {
      return [];
    }
    return data.map((r) => r.id);
  });
}}

/>

  );
};





/* ======================================================
   🏢 KURUMSAL AKORDEON — TEK FORM / ÇOKLU KULLANICI
====================================================== */
const IletisimAkordiyon = ({ selectedIds, clearSelection }) => {
  const TT = useUiTexts();
  const notify = useNotify();

  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);

const handleSend = async () => {
  if (!selectedIds?.length) {
    notify(TT.selectWarning, { type: "warning" });
    return;
  }

  const uiLang = (localStorage.getItem("app_lang") || "tr")
    .slice(0, 2)
    .toLowerCase();

  const formData = new FormData();
  formData.append("baslik", subject);
  formData.append("mesaj", message);
  formData.append("alici_ids", JSON.stringify(selectedIds));
  formData.append("language", uiLang);

  if (file) {
    formData.append("dosyalar", file); // ✅ KRİTİK SATIR
  }

  await fetch("/api/mesajlar", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: formData,
  });

  notify(`${TT.queued} (${selectedIds.length})`, { type: "success" });

  setSubject("");
  setMessage("");
  setFile(null);
  clearSelection?.();
};


  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        overflow: "hidden",
        border: `1px solid ${COLORS.border}`,
        borderRadius: 3.5,
        bgcolor: "#fff",
        boxShadow: "0 12px 34px rgba(15,23,42,.055)",
      }}
    >
      <Accordion
        defaultExpanded
        disableGutters
        elevation={0}
        sx={{
          "&::before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            minHeight: 70,
            px: { xs: 2, sm: 2.5 },
            bgcolor: "#f8fafc",
            borderBottom: `1px solid ${COLORS.border}`,
            "& .MuiAccordionSummary-content": {
              my: 1.5,
            },
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography fontWeight={950} color={COLORS.navy}>
              {TT.commCenter}
            </Typography>
            <Typography variant="body2" sx={{ color: COLORS.textSoft }}>
              {TT.bulkTitle}{" "}
              <b>{selectedIds?.length ? `(${selectedIds.length})` : ""}</b>
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: { xs: 2, sm: 2.5 } }}>
          <Stack spacing={2}>
            <MuiTextField
              label={TT.subject}
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: 2.5 },
              }}
            />

            <MuiTextField
              label={TT.message}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              multiline
              minRows={4}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: 2.5 },
              }}
            />

            <Divider />

            <Box>
              <Typography variant="body2" fontWeight={700} sx={{ mb: 1 }}>
                {TT.file}
              </Typography>

              <Box
                component="input"
                type="file"
                accept="image/*,.pdf,.doc,.docx"
                onChange={(e) => setFile(e.target.files?.[0] || null)}
                sx={{
                  width: "100%",
                  p: 1.25,
                  border: `1px dashed ${COLORS.border}`,
                  borderRadius: 2.5,
                  bgcolor: "#f8fafc",
                }}
              />

{file ? (
  <Typography
    variant="caption"
    sx={{ display: "block", mt: 1, opacity: 0.8 }}
  >
    {TT.selected}: <b>{file.name}</b>
  </Typography>
) : (
  <Typography
    variant="caption"
    sx={{ display: "block", mt: 1, opacity: 0.5 }}
  >
    {TT.noFile}
  </Typography>
)}

            </Box>

            <Button
              variant="contained"
              size="large"
              onClick={handleSend}
              sx={{
                alignSelf: { xs: "stretch", sm: "flex-end" },
                minHeight: 46,
                px: 4,
                borderRadius: 2.5,
                textTransform: "none",
                fontWeight: 900,
                bgcolor: COLORS.navy,
                "&:hover": { bgcolor: COLORS.navySoft },
              }}
            >
              {TT.send}
            </Button>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

const roleName = (role) => {
  const map = {
    admin: "Admin",
    editor: "Editor",
    user: "User",
    kurum: "Kurum",
    kullanici: "Kullanıcı",
  };

  return map[role] || role || "-";
};

function UsersListHeader() {
  const TT = useUiTexts();
  const { total, data } = useListContext();
  const count = total ?? data?.length ?? 0;

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        p: { xs: 2.25, sm: 3 },
        color: "#fff",
        background:
          "linear-gradient(125deg, #071a33 0%, #123b6d 58%, #3730a3 120%)",
        borderBottom: `4px solid ${COLORS.orange}`,
        "&::after": {
          content: '\"\"',
          position: "absolute",
          top: -150,
          right: -90,
          width: 230,
          height: 230,
          borderRadius: "50%",
          bgcolor: "rgba(255,255,255,.08)",
        },
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={2}
        sx={{ position: "relative", zIndex: 1 }}
      >
        <Box>
          <Typography
            component="h1"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem" },
              fontWeight: 950,
              letterSpacing: -0.5,
            }}
          >
            {TT.listTitle}
          </Typography>

          <Typography
            variant="body2"
            sx={{ mt: 0.4, color: "rgba(255,255,255,.76)" }}
          >
            {TT.commCenter} · {TT.bulkTitle}
          </Typography>
        </Box>

        <Box
          sx={{
            px: 1.5,
            py: 0.75,
            border: "1px solid rgba(255,255,255,.18)",
            borderRadius: 5,
            bgcolor: "rgba(255,255,255,.1)",
            fontSize: ".78rem",
            fontWeight: 850,
          }}
        >
          {count} kullanıcı
        </Box>
      </Stack>
    </Box>
  );
}

function MobileUserCard({ record, selectedIds, setSelectedIds }) {
  const TT = useUiTexts();
  const selected = selectedIds.includes(record.id);
  const created = createdFrom(record);
  const lastLogin = lastLoginFrom(record);

  return (
    <Paper
      variant="outlined"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
        borderRadius: 3.5,
        borderColor: selected ? COLORS.blue : COLORS.border,
        boxShadow: selected
          ? "0 0 0 3px rgba(37,99,235,.09)"
          : "0 10px 28px rgba(15,23,42,.055)",
      }}
    >
      <Box
        sx={{
          height: 5,
          background: record.aktif
            ? "linear-gradient(90deg, #10b981, #34d399)"
            : "linear-gradient(90deg, #94a3b8, #cbd5e1)",
        }}
      />

      <Box sx={{ p: 2 }}>
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
          spacing={1}
        >
          <Stack direction="row" spacing={1} sx={{ minWidth: 0, flex: 1 }}>
            <Checkbox
              checked={selected}
              onChange={(event) =>
                setSelectedIds((previous) =>
                  event.target.checked
                    ? [...previous, record.id]
                    : previous.filter((id) => id !== record.id)
                )
              }
              sx={{ p: 0.5, mt: -0.25 }}
            />

            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: COLORS.text,
                  fontWeight: 950,
                  overflowWrap: "anywhere",
                }}
              >
                {fullName(record)}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mt: 0.35,
                  color: COLORS.textSoft,
                  overflowWrap: "anywhere",
                }}
              >
                {record.email || "-"}
              </Typography>
            </Box>
          </Stack>

          <Box
            sx={{
              flexShrink: 0,
              px: 1,
              py: 0.45,
              borderRadius: 4,
              color: record.aktif ? "#047857" : COLORS.textSoft,
              bgcolor: record.aktif ? COLORS.greenSoft : "#f1f5f9",
              fontSize: ".7rem",
              fontWeight: 900,
            }}
          >
            {record.aktif ? TT.active : TT.passive}
          </Box>
        </Stack>

        <Divider sx={{ my: 1.5, borderColor: COLORS.border }} />

        <Stack direction="row" flexWrap="wrap" useFlexGap spacing={0.75}>
          <Box
            sx={{
              px: 1,
              py: 0.5,
              borderRadius: 4,
              color: COLORS.navy,
              bgcolor: COLORS.blueSoft,
              fontSize: ".72rem",
              fontWeight: 850,
            }}
          >
            {roleName(record.rol)}
          </Box>
        </Stack>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 1,
            mt: 1.5,
          }}
        >
          <Box>
            <Typography variant="caption" color={COLORS.textSoft}>
              {TT.createdAt}
            </Typography>
            <Typography variant="body2" fontWeight={800}>
              {created ? String(created).slice(0, 10) : "-"}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color={COLORS.textSoft}>
              {TT.lastLogin}
            </Typography>
            <Typography variant="body2" fontWeight={800}>
              {lastLogin
                ? String(lastLogin).replace("T", " ").slice(0, 16)
                : "-"}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 1.5, display: "flex", justifyContent: "flex-end" }}>
          <DeleteUserButton record={record} />
        </Box>
      </Box>
    </Paper>
  );
}

function ResponsiveUsersList({ selectedIds, setSelectedIds }) {
  const TT = useUiTexts();
  const { data = [] } = useListContext();

  return (
    <>
      <Box
        sx={{
          display: { xs: "block", lg: "none" },
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          p: 1.5,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          sx={{ mb: 1.25 }}
        >
          <SelectAllCheckbox
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
          <Typography variant="body2" fontWeight={850} color={COLORS.textSoft}>
            {selectedIds.length} seçili
          </Typography>
        </Stack>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "minmax(0, 1fr)",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            gap: 1.5,
            width: "100%",
          }}
        >
          {data.map((record) => (
            <MobileUserCard
              key={record.id}
              record={record}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
            />
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: "none", lg: "block" },
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
          "&::-webkit-scrollbar": { height: 8 },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: 8,
            bgcolor: "#cbd5e1",
          },
        }}
      >
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={{
            width: "100%",
            minWidth: 820,
            tableLayout: "fixed",
            "& .RaDatagrid-headerCell": {
              py: 1.6,
              bgcolor: "#f8fafc",
              color: COLORS.textSoft,
              fontWeight: 900,
              fontSize: ".75rem",
              textTransform: "uppercase",
              borderBottom: `1px solid ${COLORS.border}`,
            },
            "& .MuiTableCell-root": {
              py: 1.2,
              px: 1.25,
              verticalAlign: "middle",
              borderBottom: `1px solid ${COLORS.border}`,
            },
            "& .RaDatagrid-row:hover": { bgcolor: "#f8fafc" },
            "& .column-select": { width: 58, minWidth: 58 },
            "& .column-name": { width: "22%" },
            "& .column-email": { width: "24%" },
            "& .column-role": { width: 104, minWidth: 104 },
            "& .column-active": { width: 86, minWidth: 86 },
            "& .column-created": { width: 112, minWidth: 112 },
            "& .column-last": { width: 152, minWidth: 152 },
            "& .column-actions": {
              position: "sticky",
              right: 0,
              zIndex: 3,
              width: 92,
              minWidth: 92,
              bgcolor: "#fff",
              boxShadow: "-8px 0 14px rgba(15,23,42,.06)",
            },
            "& .RaDatagrid-headerCell.column-actions": {
              zIndex: 5,
              bgcolor: "#f8fafc",
            },
            "@media (max-width: 1599px)": {
              minWidth: 720,
              "& .column-last": { display: "none" },
              "& .column-name": { width: "28%" },
              "& .column-email": { width: "30%" },
            },
            "@media (max-width: 1350px)": {
              minWidth: 620,
              "& .column-created": { display: "none" },
            },
          }}
        >
          <FunctionField
            className="column-select"
            label={
              <SelectAllCheckbox
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
              />
            }
            render={(record) => (
              <Checkbox
                checked={selectedIds.includes(record.id)}
                onClick={(event) => event.stopPropagation()}
                onChange={(event) =>
                  setSelectedIds((previous) =>
                    event.target.checked
                      ? [...previous, record.id]
                      : previous.filter((id) => id !== record.id)
                  )
                }
              />
            )}
          />

          <FunctionField
            className="column-name"
            label={TT.name}
            render={(record) => (
              <Typography fontWeight={850} color={COLORS.text}>
                {fullName(record)}
              </Typography>
            )}
          />

          <EmailField className="column-email" source="email" label={TT.email} />

          <FunctionField
            className="column-role"
            label={TT.roleCol}
            render={(record) => roleName(record.rol)}
          />

          <BooleanField
            className="column-active"
            source="aktif"
            label={TT.isActive}
          />

          <FunctionField
            className="column-created"
            label={TT.createdAt}
            render={(record) => {
              const value = createdFrom(record);
              return value ? String(value).slice(0, 10) : "-";
            }}
          />

          <FunctionField
            className="column-last"
            label={TT.lastLogin}
            render={(record) => {
              const value = lastLoginFrom(record);
              return value
                ? String(value).replace("T", " ").slice(0, 16)
                : "-";
            }}
          />

          <FunctionField
            className="column-actions"
            label=""
            render={(record) => <DeleteUserButton record={record} />}
          />
        </Datagrid>
      </Box>
    </>
  );
}

/* ======================================================
   📄 LISTE (APP.JS UYUMLU)
====================================================== */
function KullanicilarPage(props) {
  const TT = useUiTexts();
  const [selectedIds, setSelectedIds] = useState([]);

  const filters = useMemo(
    () => [
      <TextInput key="q" source="q" label={TT.search} alwaysOn />,
      <SelectInput
        key="rol"
        source="rol"
        label={TT.role}
        choices={[
          { id: "admin", name: "Admin" },
          { id: "editor", name: "Editor" },
          { id: "user", name: "User" },
          { id: "kurum", name: "Kurum" },
          { id: "kullanici", name: "Kullanıcı" },
        ]}
        emptyText="—"
      />,
      <SelectInput
        key="aktif"
        source="aktif"
        label={TT.status}
        choices={[
          { id: true, name: TT.active },
          { id: false, name: TT.passive },
        ]}
        emptyText="—"
      />,
    ],
    [TT]
  );

  const clearSelection = () => setSelectedIds([]);

  return (
    <>
      <GlobalStyles
        styles={{
          ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
        }}
      />
      <List
        {...props}
        title={TT.listTitle}
        filters={filters}
        actions={<ListActions />}
        perPage={25}
        sort={{ field: "created_at", order: "DESC" }}
        sx={{
          m: 0,
          p: 0,
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          bgcolor: COLORS.page,
          "& .RaList-main": {
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
          },
          "& .RaList-content": {
            m: 0,
            p: 0,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            overflow: "hidden",
            borderRadius: { xs: 0, md: 3.5 },
            border: { md: `1px solid ${COLORS.border}` },
            boxShadow: { md: "0 18px 48px rgba(15,23,42,.07)" },
          },
          "& .MuiContainer-root": {
            maxWidth: "100% !important",
            px: "0 !important",
          },
          "& .RaList-filterForm": {
            px: { xs: 1.5, sm: 2 },
          },
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
          <UsersListHeader />

          <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
            <IletisimAkordiyon
              selectedIds={selectedIds}
              clearSelection={clearSelection}
            />
          </Box>

          <ResponsiveUsersList
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
        </Box>
      </List>
    </>
  );
}


/* ======================================================
   📄 SHOW (DETAY) — KULLANICIYA TIKLAYINCA HATA ATMASIN
====================================================== */
function KullaniciShow(props) {
  const TT = useUiTexts();

  // Record bazen ilk render’da null gelebiliyor, patlamasın:
  const SafeName = () => {
    const r = useRecordContext();
    return <span>{r ? fullName(r) : "-"}</span>;
  };

  const SafeCreated = () => {
    const r = useRecordContext();
    const v = r ? createdFrom(r) : null;
    return <span>{v ? String(v).slice(0, 10) : "-"}</span>;
  };

  const SafeLastLogin = () => {
    const r = useRecordContext();
    const v = r ? lastLoginFrom(r) : null;
    return <span>{v ? String(v).replace("T", " ").slice(0, 16) : "-"}</span>;
  };

  return (
    <>
      <GlobalStyles
        styles={{
          ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
        }}
      />
      <Show {...props} title={TT.detailsTitle}>
        <SimpleShowLayout>
          <FunctionField label={TT.name} render={() => <SafeName />} />
          <EmailField source="email" label={TT.email} />
          <TextField source="rol" label={TT.roleCol} />
          <BooleanField source="aktif" label={TT.isActive} />
          <FunctionField label={TT.createdAt} render={() => <SafeCreated />} />
          <FunctionField label={TT.lastLogin} render={() => <SafeLastLogin />} />
        </SimpleShowLayout>
      </Show>
    </>
  );
}

/* ======================================================
   🔚 EXPORTLAR (APP.JS UYUMLU)
====================================================== */
export default KullanicilarPage;
export { KullanicilarPage, KullaniciShow };
